
const actions = {
    OPEN_DRAWER: 'OPEN_DRAWER',
    OPEN_DRAWER_DETAIL: 'OPEN_DRAWER_DETAIL',
    CLOSE_DRAWER: 'CLOSE_DRAWER',
    SET_JORNADAS: 'SET_JORNADAS',
    SET_PERSONAL_DISPONIBLE: 'SET_PERSONAL_DISPONIBLE',
    openDrawer: (action, day, turn) => ({
        type: actions.OPEN_DRAWER,
        payload: { action, day, turn }
    }),
    closeDrawer: () => ({
        type: actions.CLOSE_DRAWER
    }),
    setJornadas: (jornadas) => ({
        type: actions.SET_JORNADAS,
        payload: { jornadas }
    }),
    setPersonalDisponible: (personalDisponible) => ({
        type: actions.SET_PERSONAL_DISPONIBLE,
        payload: { personalDisponible }
    })
};
export default actions;
